import { post, parseData } from '../api/common';
import { responseHandler } from '../api/api';
const getCompaniesForSwitchAsAdmin = (EmpPK) => {
    return post('/InternalAPI/SwitchCompanyAPI.asmx/GetCompaniesForSwitchAsAdmin', { EmpPK })
        .then(parseData)
        .then(responseHandler);
};
const switchCompanyAsAdmin = (EmpPK, CompanyPK) => {
    return post('/InternalAPI/SwitchCompanyAPI.asmx/SwitchCompanyAsAdmin', { EmpPK, CompanyPK })
        .then(parseData)
        .then(responseHandler);
};
export { getCompaniesForSwitchAsAdmin, switchCompanyAsAdmin };
